import axios, { AxiosResponse, InternalAxiosRequestConfig, AxiosHeaders } from "axios";
import { tcGetLoginInfo, tcTokenLoseEfficacy, isApp, tcGetSaveData } from "@/utils/bridge/index.js";
import { decrypt } from "./crypto.js";
const oldTokenId = "7ef37b90507541f288740b9cc818a40c";

// 定义 Toast 队列
const toastQueue: string[] = [];
let isShowingToast = false;
// 显示 Toast 队列中的消息
const showToastFromQueue = () => {
  if (toastQueue.length > 0 && !isShowingToast) {
    isShowingToast = true;
    const message = toastQueue.shift()!;
    // showToast(message)
    // 假设 showToast 函数返回一个 Promise，在 Toast 关闭后再展示下一个
    showToast({
      message,
      onClose: () => {
        isShowingToast = false;
        showToastFromQueue();
      },
    });
  }
};

const http = axios.create({
  baseURL: import.meta.env.VITE_APP_URL, // 替换为你的API基地址
  timeout: 30000, // 请求超时时间
});

// 请求拦截器
http.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const { url } = config;
    if (url != "/home/init" && !isApp()) {
      showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        closeOnClick: true,
      });
    }

    // 可以在这里添加例如token等请求头T
    if (!config.headers) {
      config.headers = new AxiosHeaders();
    }
    config.headers["Authorization"] = await tcGetLoginInfo();
    // if(isApp()){ // app 内传app的渠道号如huawei，xiaomi 等 h5 传 channelNUmber 如 YSDXA01A01011 等 。
    config.headers["appChannel"] = await tcGetSaveData("appChannel");
    config.headers["sourceType"] = isApp() ? await tcGetSaveData("sourceType") : "h5";
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    return config;
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

import { useBubbleGuide } from "@/composables/useBubbleGuide";
const { safeClearStorage } = useBubbleGuide();

// 响应拦截器
http.interceptors.response.use(
  async (response: AxiosResponse) => {
    closeToast();
    // 对响应数据做处理，例如只返回data部分
    const { code, message } = response.data;
    const { url } = response.config;
    if (code == "10010" && url?.indexOf("/findOne") == -1) {
      tcTokenLoseEfficacy();
      return {
        data: "{}",
        code: "10010",
        message: "退出登录",
      };
    }
    if (code == "10010") {
      safeClearStorage();
    }
    if (code != 0 && url?.indexOf("/findOne") == -1 && url?.indexOf("/ocr/live-ness") == -1) {
      // 检查请求是否设置了 noDecryption，如果是则不解密 message
      // noDecryption 是在 request.js 中作为 axios config 传入的，不是 headers
      const noDecryption = (response.config as any).noDecryption;
      let msg: { message?: string };
      if (noDecryption) {
        // 不需要解密，直接使用原始 message
        msg = { message };
      } else {
        // 需要解密
        let str = message.replace(/[\n\t\s]+/g, "");
        const newMsg = decrypt(str, oldTokenId);
        msg = typeof newMsg === "string" ? JSON.parse(newMsg) : newMsg;
      }

      // 还款计划接口 错误码非0 都提示为还款计划生成中
      if (url?.indexOf("/loan-plan/quantify/list") != -1) {
        msg.message = "还款计划生成中，请稍后再试";
      }
      // 将消息添加到队列
      showToast(msg.message || "请求失败，请稍后重试");
      // toastQueue.push(msg.message);
      // showToastFromQueue();
      response.data.message = msg.message;
    }
    return response.data;
  },
  (error) => {
    // 响应错误处理
    closeToast();
    return Promise.reject(error);
  }
);

export default http;
